import { BaseEntity } from '../base-entity';
import { Report } from './report';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContext, AuthzContextsActionMap, CrudAction } from '@mri-platform/resource-authz';
/// </code-import>

export interface Bookmark {
  id: string;
  isDefault: boolean;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  name: string;
  needsReview: boolean;
  periodEnd: Date;
  periodStart: Date;
  reportId: string;
  state: string;
  tenantKey: string;
  report: Report;
}

/// <module-code> Place module level code between <module-code> tags
const typeFuncs = BaseEntity.makeStaticTypeFunctions<Bookmark>(EntityName.Bookmark);
/// </module-code>

export class Bookmark extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static propName = typeFuncs.propName;
  static propNames = typeFuncs.propNames;
  static qualifiedPropName = typeFuncs.qualifiedPropName;
  static qualifiedPropNames = typeFuncs.qualifiedPropNames;

  static authorization: AuthzContextsActionMap = {
    ...AuthzContextsActionMap.crudFor(EntityName.Bookmark),
    [CrudAction.Update]: AuthzContext.updateFor(...Bookmark.qualifiedPropNames('state', 'name', 'isDefault'))
  };

  static bookmarkSortByName(a: { name: string }, b: { name: string }): number {
    return a.name.localeCompare(b.name);
  }
  /// </code>
  // Generated code. Do not place code below this line.
}
